import { render, staticRenderFns } from "./PublicReviewView.vue?vue&type=template&id=fa8e558a&scoped=true&"
import script from "./PublicReviewView.vue?vue&type=script&lang=js&"
export * from "./PublicReviewView.vue?vue&type=script&lang=js&"
import style0 from "./PublicReviewView.vue?vue&type=style&index=0&id=fa8e558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8e558a",
  null
  
)

export default component.exports